<script>
    import { onMount } from "svelte";
    import Library from '../../Models/LibraryORM';
    import SortableTable from '../SortableTable.svelte';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import { notifier } from '@beyonk/svelte-notifications';
    import { confirm } from "../Confirmation.svelte";
    import parseFields from '../../Utilities/parseFields';

    export let section;
    export let added_items;
    export let assessment_model;

    let sortFields;
    let formFields;

    function editItem(item) {
        addFormModal({
            fields: formFields,
            data: item
        }).then(formData => {
            assessment_model.saveLibraryItem(section, formData).then(() => {
                notifier.success("Item Updated");
            });
        })
    }

    function deleteItem(item) {
        confirm(`Are you sure you want to remove "${item.name}" from the report?`).then(() => {
            assessment_model.deleteLibraryItem(item).then(() => {
                notifier.success("Item removed");
            }).catch(() => null);
        }).catch(() => null);
    }

    onMount(async () => {
        let fields = await Library.getFieldData(section.library_type);

        sortFields = fields.sortFields;
        formFields = fields.formFields;

        if (section.extra_fields) {
            let extra_fields = parseFields(section.extra_fields, false);

            sortFields = [...sortFields, ...extra_fields.sortFields];
            formFields = [...formFields, ...extra_fields.formFields];
        }
    });
</script>

{#if sortFields}
    <SortableTable {sortFields} tableData={added_items} paged={false} showHideFields={false}>
        <div slot="rowActions" class="buttons" let:row={item}>
            <div class="button is-info" on:click={() => editItem(item)}>Edit Item</div>
            <div class="button is-danger" on:click={() => deleteItem(item)}>Delete Item</div>
        </div>
    </SortableTable>
{/if}